export const categoriesValidations = {
    13: (data) => {
        if (parseInt(data.brokerageEquities) + parseInt(data.brokerageCash) + parseInt(data.brokerageFixedIncome) + parseInt(data.brokerageCrypto) + parseInt(data.brokerageReits) > 100){
            return {isValid:false,message:'Sum of allocation cannot be more than 100%'}
        }
        return {isValid:true}
    }
}